"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isPlan(object) {
    return checkPlan(object).fulfilled;
}
exports.isPlan = isPlan;
function checkPlan(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("stripeId"), __1.hasString("name"), __1.hasNumber("grade").integer(), __1.hasChoice("paymentInterval", ["MONTHLY", "YEARLY"]), __1.hasMap("costPerUser", __1.isNumber())).withOptions(options).explain();
}
exports.checkPlan = checkPlan;
//# sourceMappingURL=Plan.js.map